const colors = {
  primary: "#00BDFF",
  mainDark: "#282828",
  mainWhite: "#ffffff",
  grey: "#E2E5E8",
  buttonDisabled: "#7B91B0",
};

export default colors;
